export default {
  EcomAttrinutes: {},
  singleAttrinutesPrime: {},
  singleAttrinutesSec: {},
  attributePopupOpen: false,
  attributeValPopup: false,
  onClickProduct: {},
};
